/**
 * @license
 * @copyright Copyright Motili Inc., 2021 All Rights Reserved
 */

import { ReactElement, ReactNode } from 'react';
import { styled } from 'styled-components';

interface UnorderedListProps {
    children: ReactNode;
}

export default function UnorderedList({
    children,
}: UnorderedListProps): ReactElement {
    return <List>{children}</List>;
}

const List = styled.ul`
    font-family: 'Nunito Sans', Helvetica, Arial, sans-serif;
    font-size: 14px;
    font-weight: regular;
    color: #333333;
    line-height: 30px;
    @media (max-width: 500px) {
        padding-inline-start: 30px;
    }
`;
